import { render } from "./WhiteboardToolbar.vue?vue&type=template&id=3782ed06&scoped=true"
import script from "./WhiteboardToolbar.vue?vue&type=script&lang=js"
export * from "./WhiteboardToolbar.vue?vue&type=script&lang=js"

import "./WhiteboardToolbar.vue?vue&type=style&index=0&id=3782ed06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3782ed06"]])

export default __exports__